import { createApp } from 'vue';
import TakeoverVideoBlock from './TakeoverVideoBlock.vue';

const formEl = document.querySelector('[data-feature="takeoverVideoBlock"]');
if (formEl) {
	const app = createApp({
		name: 'TakeoverVideoBlockApp',
	});

	app.component('takeover-video-block', TakeoverVideoBlock);

	app.mount(formEl);
}
